/**
 * CodeSkin shop toolbar — custom light dropdowns (sort + filter pill styling).
 */
(function () {
  function closeAllMenus(except) {
    document.querySelectorAll('[data-codeskin-custom-select].is-open').forEach(function (wrap) {
      if (wrap === except) return;
      wrap.classList.remove('is-open');
      var trigger = wrap.querySelector('[data-codeskin-select-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      var menu = wrap.querySelector('[data-codeskin-select-menu]');
      if (menu) {
        menu.hidden = true;
        clearMobileSortMenuStyles(menu);
      }
    });
  }

  var mobileSortMq =
    typeof window.matchMedia === 'function' ? window.matchMedia('(max-width: 900px)') : null;

  function clearMobileSortMenuStyles(menu) {
    if (!menu) return;
    menu.style.position = '';
    menu.style.top = '';
    menu.style.bottom = '';
    menu.style.left = '';
    menu.style.right = '';
    menu.style.width = '';
    menu.style.maxHeight = '';
    menu.style.zIndex = '';
  }

  function positionMobileSortMenu(wrap, menu) {
    if (!menu || !mobileSortMq || !mobileSortMq.matches) {
      clearMobileSortMenuStyles(menu);
      return;
    }
    var trigger = wrap && wrap.querySelector('[data-codeskin-select-trigger]');
    if (!trigger) return;

    var rect = trigger.getBoundingClientRect();
    var menuWidth = Math.max(Math.round(rect.width), 200);
    var left = Math.min(rect.left, window.innerWidth - menuWidth - 12);
    left = Math.max(12, left);

    menu.style.position = 'fixed';
    menu.style.top = Math.round(rect.bottom + 6) + 'px';
    menu.style.bottom = 'auto';
    menu.style.left = left + 'px';
    menu.style.right = 'auto';
    menu.style.width = menuWidth + 'px';
    menu.style.maxHeight = Math.max(140, window.innerHeight - rect.bottom - 20) + 'px';
    menu.style.zIndex = '100030';
  }

  function closeAllFilterDropdowns(except) {
    document.querySelectorAll('[data-codeskin-filter-dropdown].is-open').forEach(function (wrap) {
      if (wrap === except) return;
      wrap.classList.remove('is-open');
      var trigger = wrap.querySelector('.codeskin-filter-dropdown__trigger');
      var panel = wrap.querySelector('[data-codeskin-filter-panel]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
  }

  function initFilterDropdown(wrap) {
    if (!wrap || wrap.dataset.filterDropdownBound === 'true') return;
    var trigger = wrap.querySelector('.codeskin-filter-dropdown__trigger');
    var panel = wrap.querySelector('[data-codeskin-filter-panel]');
    if (!trigger || !panel) return;
    wrap.dataset.filterDropdownBound = 'true';

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var willOpen = !wrap.classList.contains('is-open');
      closeAllFilterDropdowns(wrap);
      closeAllMenus(null);
      if (willOpen && wrap.closest('.codeskin-col-filter-sheet__facet-group--availability')) {
        document.querySelectorAll('[data-codeskin-sheet-dropdown]').forEach(function (block) {
          var navPanel = block.querySelector('[data-codeskin-sheet-dropdown-panel]');
          var navTrigger = block.querySelector('[data-codeskin-sheet-dropdown-trigger]');
          if (navPanel) navPanel.hidden = true;
          if (navTrigger) navTrigger.setAttribute('aria-expanded', 'false');
          block.classList.remove('is-open');
        });
      }
      wrap.classList.toggle('is-open', willOpen);
      panel.hidden = !willOpen;
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (willOpen && wrap.closest('[data-codeskin-col-filter-sheet]')) {
        document.querySelectorAll('[data-codeskin-sheet-dropdown]').forEach(function (block) {
          var navPanel = block.querySelector('[data-codeskin-sheet-dropdown-panel]');
          var navTrigger = block.querySelector('[data-codeskin-sheet-dropdown-trigger]');
          if (navPanel) navPanel.hidden = true;
          if (navTrigger) navTrigger.setAttribute('aria-expanded', 'false');
          block.classList.remove('is-open');
        });
        window.requestAnimationFrame(function () {
          wrap.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        });
      }
    });

    panel.addEventListener('click', function (event) {
      event.stopPropagation();
    });
  }

  function initFilterDropdowns(scope) {
    (scope || document).querySelectorAll('[data-codeskin-filter-dropdown]').forEach(initFilterDropdown);
  }

  window.initCodeskinFilterDropdowns = initFilterDropdowns;
  window.closeAllCodeskinFilterDropdowns = closeAllFilterDropdowns;

  function initCustomSelect(wrap) {
    if (!wrap || wrap.dataset.selectBound === 'true') return;
    var select = wrap.querySelector('select');
    if (!select) return;
    wrap.dataset.selectBound = 'true';

    select.classList.add('codeskin-sort-select--native');
    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'codeskin-select__trigger';
    trigger.setAttribute('data-codeskin-select-trigger', '');
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var label = document.createElement('span');
    label.className = 'codeskin-select__value';
    label.setAttribute('data-codeskin-select-label', '');

    var chevron = document.createElement('span');
    chevron.className = 'codeskin-select__chevron';
    chevron.setAttribute('aria-hidden', 'true');
    chevron.innerHTML =
      '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="6 9 12 15 18 9"/></svg>';

    trigger.appendChild(label);
    trigger.appendChild(chevron);

    var menu = document.createElement('ul');
    menu.className = 'codeskin-select__menu';
    menu.setAttribute('data-codeskin-select-menu', '');
    menu.setAttribute('role', 'listbox');
    menu.hidden = true;

    function syncLabel() {
      var opt = select.options[select.selectedIndex];
      label.textContent = opt ? opt.textContent.trim() : '';
    }

    Array.prototype.forEach.call(select.options, function (option) {
      var item = document.createElement('li');
      item.setAttribute('role', 'option');
      item.className = 'codeskin-select__option';
      item.dataset.value = option.value;
      item.textContent = option.textContent.trim();
      if (option.selected) item.setAttribute('aria-selected', 'true');
      item.addEventListener('click', function () {
        select.value = option.value;
        menu.querySelectorAll('.codeskin-select__option').forEach(function (el) {
          el.removeAttribute('aria-selected');
        });
        item.setAttribute('aria-selected', 'true');
        syncLabel();
        wrap.classList.remove('is-open');
        menu.hidden = true;
        clearMobileSortMenuStyles(menu);
        trigger.setAttribute('aria-expanded', 'false');
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
      menu.appendChild(item);
    });

    trigger.addEventListener('click', function (event) {
      event.stopPropagation();
      var willOpen = !wrap.classList.contains('is-open');
      closeAllFilterDropdowns(null);
      closeAllMenus(wrap);
      wrap.classList.toggle('is-open', willOpen);
      menu.hidden = !willOpen;
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (willOpen) {
        window.requestAnimationFrame(function () {
          positionMobileSortMenu(wrap, menu);
        });
      } else {
        clearMobileSortMenuStyles(menu);
      }
    });

    select.addEventListener('change', syncLabel);
    syncLabel();

    wrap.appendChild(trigger);
    wrap.appendChild(menu);
  }

  function boot() {
    document.querySelectorAll('[data-codeskin-custom-select]').forEach(initCustomSelect);
    initFilterDropdowns(document);

    if (!window.__codeskinSelectCloseBound) {
      window.__codeskinSelectCloseBound = true;
      document.addEventListener('click', function () {
        closeAllMenus(null);
        closeAllFilterDropdowns(null);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeAllMenus(null);
          closeAllFilterDropdowns(null);
        }
      });
      window.addEventListener('resize', function () {
        document.querySelectorAll('[data-codeskin-custom-select].is-open').forEach(function (wrap) {
          var menu = wrap.querySelector('[data-codeskin-select-menu]');
          if (menu && !menu.hidden) positionMobileSortMenu(wrap, menu);
        });
      });
      window.addEventListener(
        'scroll',
        function () {
          document.querySelectorAll('[data-codeskin-custom-select].is-open').forEach(function (wrap) {
            var menu = wrap.querySelector('[data-codeskin-select-menu]');
            if (menu && !menu.hidden) positionMobileSortMenu(wrap, menu);
          });
        },
        true
      );
    }
  }

  window.initCodeskinCollectionToolbar = function (root) {
    var scope = root || document;
    scope.querySelectorAll('[data-codeskin-custom-select]').forEach(initCustomSelect);
    initFilterDropdowns(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
